document.addEventListener("DOMContentLoaded", function (event) {
  function initializeSwiper(sectionId, settings) {
    var params = {
      slidesPerView: 'auto',
      spaceBetween: settings.gap_m,
      centerInsufficientSlides: true,
      breakpoints: {
        750: {
          spaceBetween: settings.gap,
        },
      }
    };

    // Add autoplay settings if enabled
    if (settings.autoplay === true) {
      params.loop = true;
      params.speed = 2000;
      params.autoplay = {
        delay: 400
      };
    }

    const swiperEl = document.querySelector('.section-block-' + sectionId + ' swiper-container');
    if (swiperEl) {
      Object.assign(swiperEl, params);
      swiperEl.initialize();
    }
  }

  // Initialize all logo swipe sections on the page
  // This will be called with settings passed from the liquid template
  window.initializeLogoSwiper = initializeSwiper;
});